/**
 * UNITED BY GRIT purchase gate.
 * Launch: 2026-10-15 08:00 Asia/Kolkata. Browser timezone is ignored.
 */
(function () {
  var root = document.querySelector('[data-ubg-launch]');
  if (!root) return;

  var iso = root.getAttribute('data-ubg-launch');
  var launchAt = Date.parse(iso);
  if (!launchAt) return;

  var prelaunchLabel = root.getAttribute('data-ubg-prelaunch-label') || 'ADD TO CART — 8 AM';
  var liveLabel = root.getAttribute('data-ubg-live-label') || 'ADD TO CART';
  var originalAddToCart =
    window.theme && window.theme.strings ? window.theme.strings.addToCart : liveLabel;
  var timer = null;

  function launched() {
    return Date.now() >= launchAt;
  }

  function purchaseControls() {
    return document.querySelectorAll(
      '.template-product-grit [data-add-to-cart], .template-product-grit [data-cart-bar-add-to-cart], .template-product-grit .shopify-payment-button button, .template-product-grit .shopify-payment-button [role="button"]'
    );
  }

  function setDisabled(isDisabled) {
    purchaseControls().forEach(function (control) {
      control.toggleAttribute('disabled', isDisabled);
      control.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
    });

    document.querySelectorAll('.template-product-grit .shopify-payment-button').forEach(function (wrap) {
      wrap.hidden = isDisabled;
    });
  }

  function setLabels(text) {
    document.querySelectorAll('.template-product-grit [data-add-to-cart-text]').forEach(function (node) {
      var price = node.querySelector('[data-product-price]');
      var priceHtml = price ? price.outerHTML : '';
      node.textContent = text;
      if (priceHtml) node.insertAdjacentHTML('beforeend', ' ' + priceHtml);
    });
    if (window.theme && window.theme.strings) {
      window.theme.strings.addToCart = text;
    }
  }

  function apply() {
    var isLive = launched();
    document.documentElement.classList.toggle('ubf-grit-prelaunch', !isLive);
    document.documentElement.classList.toggle('ubf-grit-live', isLive);
    root.hidden = isLive;
    setDisabled(!isLive);
    setLabels(isLive ? originalAddToCart || liveLabel : prelaunchLabel);

    if (isLive && timer) {
      window.clearTimeout(timer);
      timer = null;
    }
  }

  function blockIfGated(event) {
    if (launched()) return;
    var target = event.target;
    if (!target || !target.closest) return;
    if (!document.body.classList.contains('template-product-grit')) return;

    var form = target.closest('[data-product-form], form[data-type="add-to-cart-form"]');
    var control = target.closest(
      '[data-add-to-cart], [data-cart-bar-add-to-cart], [name="add"], .shopify-payment-button'
    );
    if (!form && !control) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  document.addEventListener('click', blockIfGated, true);
  document.addEventListener('submit', blockIfGated, true);
  document.addEventListener(
    'theme:cart:add',
    function (event) {
      if (launched()) return;
      event.stopImmediatePropagation();
    },
    true
  );

  apply();

  var remaining = launchAt - Date.now();
  if (remaining > 0) {
    timer = window.setTimeout(apply, remaining + 50);
  }

  if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, apply);
  }

  var form = document.querySelector('.template-product-grit product-form');
  if (form && window.MutationObserver) {
    new MutationObserver(function () {
      if (!launched()) setDisabled(true);
    }).observe(form, { attributes: true, subtree: true, attributeFilter: ['disabled'] });
  }
})();
